import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { parseUIPercents } from "../../../utils"
import * as S from "../../Landing/Styled"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.org/docs/use-static-query/
 */

export const Icons = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage1: file(
        relativePath: { eq: "icons/icon-dribbble@2x.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 48, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      placeholderImage2: file(
        relativePath: { eq: "icons/icon-behance@2x.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 48, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      placeholderImage3: file(
        relativePath: { eq: "icons/icon-medium@2x.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 48, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      placeholderImage4: file(
        relativePath: { eq: "icons/icon-linked-in@2x.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 48, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      placeholderImage5: file(
        relativePath: { eq: "icons/icon-instagram@2x.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 48, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <>
      <S.DribbleLink
        onClick={() => window.open("https://dribbble.com/Kida", "_blank")}
      >
        <Img fluid={data.placeholderImage1.childImageSharp.fluid} />
      </S.DribbleLink>
      <S.BehanceLink
        onClick={() => window.open("https://www.behance.net/KidaJ", "_blank")}
      >
        <Img fluid={data.placeholderImage2.childImageSharp.fluid} />
      </S.BehanceLink>
      <S.MediumLink
        onClick={() => window.open("https://medium.com/@kidajl", "_blank")}
      >
        <Img fluid={data.placeholderImage3.childImageSharp.fluid} />
      </S.MediumLink>
      <S.LinkedLink
        onClick={() =>
          window.open(
            "https://www.linkedin.com/in/kida-hsu-b315b2a7/",
            "_blank"
          )
        }
      >
        <Img fluid={data.placeholderImage4.childImageSharp.fluid} />
      </S.LinkedLink>
      <S.InstagramLink
        onClick={() =>
          window.open("https://www.instagram.com/kidajl/", "_blank")
        }
      >
        <Img fluid={data.placeholderImage5.childImageSharp.fluid} />
      </S.InstagramLink>
    </>
  )
}
